export default "__VITE_ASSET__65bec281__"